export default __webpack_public_path__ + "static/media/edit-icon.9b527df0.svg";